// extracted by mini-css-extract-plugin
export default {"title":"AttendanceDialog_title__hiKc4","content":"AttendanceDialog_content__+Jols","form":"AttendanceDialog_form__7qYKa","buttons":"AttendanceDialog_buttons__gJs2v"};